module.exports = __webpack_public_path__ + "img/role01.0ff78cf0.png";